import { PreviewPaneMode, PreviewPaneViewState } from 'owa-sxsdata';

export default function shouldUseHighContrastCommandBar(
    previewPane: PreviewPaneViewState,
    neverUse?: boolean
): boolean {
    if (neverUse) {
        return false;
    }

    if (previewPane) {
        if (previewPane.useHighContrastCommandBar) {
            return true;
        }

        if (
            previewPane.mode === PreviewPaneMode.Image ||
            previewPane.mode === PreviewPaneMode.Audio ||
            previewPane.mode === PreviewPaneMode.Video
        ) {
            return true;
        }
    }

    return false;
}
